export enum LocalStorageType {
    Menu = 'menu',
    ModaWebToken = 'modaWebToken',
    JwtToken = 'jwtToken',
    Branches = 'branches',
    CallbackUrl = 'callbackUrl',
    Tenant = 'tenant',
    UserDocument = 'userDocument',
    UrlTenant = 'urlTenant',
    themeImage = 'themeImage'
}
